<template>
  <div class="wizzard__form">
    <template v-if="account">
      <StepAccountModes
        v-model="useExisting"
        :has-existing-accounts
        name="account"
      />
      <StepAccountForm
        :transaction
        :account
        :use-existing="useExisting"
      />
    </template>
    <template v-else>
      <div class="wizzard-step-account__entities">
        <div
          v-for="(entity, index) in entities"
          :key="entity.key"
          class="wizzard-step-account__entity"
        >
          <div class="wizzard-step-account__entity-head">
            <StepAccountModes
              v-model="entity.useExisting"
              :has-existing-accounts
              name="entity"
            />
            <UIButtonIcon
              v-if="entities.length > 1"
              v-tooltip.top="'Remove investor'"
              variant="danger"
              fill="light"
              size="xxs"
              :leading="TrashIcon"
              @click="multi?.remove(index)"
            />
          </div>
          <StepAccountForm
            :transaction="entity.transaction"
            :account="entity.account"
            :use-existing="entity.useExisting"
          />
        </div>
        <UIButton
          label="Add another investor"
          variant="secondary"
          :size
          :leading="PlusIcon"
          @click="multi?.add()"
        />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import { PlusIcon, TrashIcon } from '@heroicons/vue/24/outline'

import { AssetClass, ButtonSize, TransactionClass } from '@types'
import { MULTI_ENTITY_CONTEXT } from '../utils/const'

import { UIButton, UIButtonIcon } from '@ui/buttons'
import StepAccountModes from './StepAccountModes.vue'
import StepAccountForm from './StepAccountForm.vue'

type Props = {
  transaction?: TransactionClass
  account?: AssetClass
  asset: AssetClass
  hasExistingAccounts: boolean
}

defineProps<Props>()

defineOptions({ inheritAttrs: false })

const useExisting = defineModel<boolean>('useExistingAccount')

const size = inject<ButtonSize>('size')
const multi = inject(MULTI_ENTITY_CONTEXT)

const entities = computed(() => multi?.entities?.value ?? [])
</script>

<style>
.wizzard-step-account {
  @apply flex flex-col gap-2;

  &__entities {
    @apply flex flex-col gap-4;
  }

  &__entity {
    @apply flex flex-col gap-3 rounded-lg border border-common-border p-4;
  }

  &__entity-head {
    @apply flex items-start justify-between;

    .ui-button-icon {
      @apply -mt-1 -mr-1;
    }
  }
}
</style>
